import FeedbackCarousel from "../../../components/FeedbackCarousel/FeedbackCarousel";
import {Link} from 'react-router-dom';

const WhyChooseUs = () => {
  return (
    <div className="about-us">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6">
            <div className="t-c text-md-left">
              <div className="about-us-heading mb-3">Why Choose Us?</div>
              <p className="mb-4 cap">
                What makes Panorama stand out of the ordinary isn’t our history of providing
                exceptional work on time, rather building long-lasting company-client relationships.
                We are a one stop shop for all your business technology needs. We are much more than a
                company; we are your business partner, just a phone call away, 24/7. Let’s connect!
              </p>
              <Link to="about-us" className="th-btn btn-fill-dar">Read More</Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <FeedbackCarousel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
